// More types can be added as necessary, just avoid any complex types (objects, functions) since this implementation doesn't cater for them.
type Primitive = string;

export const deduplicatePrimitiveArray = <T extends Primitive>(
  primitiveArray: ReadonlyArray<T>,
) => {
  return [...new Set(primitiveArray)];
};
